import { BaseSdk } from '../../base.sdk';
import { GlobalSearchResponseDto } from '@zaplify/prospects';

export class SearchSdk extends BaseSdk {
    async globalSearch(query: string) {
        return await this.get<GlobalSearchResponseDto>(`${this.search}?${query}`);
    }
}
